/**
 * @file   : SectionHeader.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/15/2019, 6:25:49 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import Cont, {
  ALIGN_CENTER,
  ALIGN_RIGHT,
} from '../../../external/components/layout/Cont'
import Section, { SUB } from '../../../external/components/layout/Section'
import AIconAction from '../../../external/components/link/AIconAction'
import { createSimpleLinkProps } from '../../../external/components/link/LinkUtils'
import TextHoverable from '../../../external/components/link/TextHoverable'
import HTag from '../../../external/components/text/HTag'
import { isEmpty } from '../../../external/utilities/GeneralUtils'
import { getTranslation } from '../InfoUtil'

const SectionHeader = ({ intl, section, infoData }) => {
  const getSectionHeaderUI = function () {
    let titleUI = null
    let sectionLinkUI = null

    const titleText = getTranslation(
      intl,
      section.title.token,
      section.title.default,
      infoData.infoToken,
    )
    const linkText = getTranslation(
      intl,
      section.sectionLink.description.token,
      section.sectionLink.description.default,
      infoData.infoToken,
    )

    if (!isEmpty(titleText)) {
      titleUI = (
        <Cont align={ALIGN_CENTER}>
          <HTag h2>
            <TextHoverable
              asSpan
              selected
              fontSizeType={2}
              fontFamily={'Figtree'}
              fontWeight={'600'}
            >
              {getTranslation(
                intl,
                section.title.token,
                section.title.default,
                infoData.infoToken,
              )}
            </TextHoverable>
          </HTag>
        </Cont>
      )
    }

    if (!isEmpty(linkText)) {
      sectionLinkUI = (
        <Cont align={ALIGN_RIGHT} className="section-header__action">
          <AIconAction
            label={getTranslation(
              intl,
              section.sectionLink.description.token,
              section.sectionLink.description.default,
              infoData.infoToken,
            )}
            faStyle={'fa-arrow-right'}
            isShowAsLink
            iconPos={'right'}
            {...createSimpleLinkProps(
              section.sectionLink.link,
              section.sectionLink.linkInternal,
              section.sectionLink.newWindow,
            )}
          />
        </Cont>
      )
    }

    if (titleUI === null && sectionLinkUI === null) {
      return null
    }

    return (
      <Cont>
        {titleUI}
        {sectionLinkUI}
      </Cont>
    )
  }

  const sectionHeaderUI = getSectionHeaderUI(section)

  if (sectionHeaderUI === null) {
    return null
  }

  return (
    <Cont>
      <Section />
      <Section>
        <Section style={SUB}>{getSectionHeaderUI(section)}</Section>
      </Section>
    </Cont>
  )
}

SectionHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  section: PropTypes.object,
  infoData: PropTypes.object,
}

export default SectionHeader
